import { Component } from '@angular/core';
import { COVERAGE_BUDGET_WHATSAPP_URL } from '../../data/events.data';
import { PillButtonComponent } from '../../shared/ui/pill-button/pill-button.component';

@Component({
  selector: 'app-budget-cta',
  standalone: true,
  imports: [PillButtonComponent],
  templateUrl: './budget-cta.component.html',
  styleUrl: './budget-cta.component.scss',
})
export class BudgetCtaComponent {
  readonly whatsappUrl = COVERAGE_BUDGET_WHATSAPP_URL;
}
